import React, { useState } from 'react';

const TestimonialSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      name: "Sarah Johnson",
      company: "Tech Solutions Inc.",
      role: "HR Director",
      text: "Kalaratan's Gifts transformed our corporate gifting experience. The quality and attention to detail exceeded our expectations. Our clients were absolutely delighted!",
      rating: 5,
      avatar: "👩‍💼"
    },
    {
      name: "Rajesh Patel",
      company: "Heritage Crafts",
      role: "Cultural Director",
      text: "The traditional gifts showcase authentic craftsmanship. Perfect for our cultural events and festivals. Highly recommend for anyone seeking genuine artistry.",
      rating: 5,
      avatar: "👨‍🎨"
    },
    {
      name: "Emily Chen",
      company: "Personal Customer",
      role: "Wedding Planner",
      text: "Their handmade collection is absolutely stunning! Each piece tells a story. Made our wedding favors truly special and memorable for all our guests.",
      rating: 5,
      avatar: "👰"
    },
    {
      name: "Michael Rodriguez",
      company: "Global Enterprises",
      role: "CEO",
      text: "Professional service, premium quality, and timely delivery. Kalaratan's Gifts has become our go-to partner for all corporate gifting needs.",
      rating: 5,
      avatar: "👨‍💼"
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-burlap-50 via-cream-50 to-burlap-100 burlap-texture px-4 sm:px-6 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-64 h-64 bg-primary-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse-slow"></div>
        <div className="absolute bottom-20 right-20 w-64 h-64 bg-accent-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse-slow"></div>
      </div>

      <div className="relative container mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-xs sm:text-sm font-bold text-accent-600 uppercase tracking-widest bg-accent-100 px-3 sm:px-4 py-2 rounded-full">
              Client Testimonials
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-display font-bold text-burlap-800 mb-4 sm:mb-6">
            What Our <span className="gradient-gold">Clients Say</span>
          </h2>
          <p className="text-lg sm:text-xl text-burlap-600 max-w-4xl mx-auto leading-relaxed">
            Don't just take our word for it. Here's what our valued clients have to say about their experience
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 text-center shadow-2xl border-2 border-cream-200">
            <div className="mb-6 sm:mb-8">
              {/* Stars */}
              <div className="flex justify-center mb-4 sm:mb-6">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                  <span key={i} className="text-luxury-400 text-xl sm:text-2xl">⭐</span>
                ))}
              </div>
              
              {/* Quote */}
              <blockquote className="text-lg sm:text-xl md:text-2xl text-burlap-700 italic leading-relaxed mb-6 sm:mb-8 font-light">
                "{testimonials[currentTestimonial].text}"
              </blockquote>
              
              {/* Avatar and Info */}
              <div className="flex items-center justify-center space-x-4">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center text-xl sm:text-2xl shadow-lg">
                  {testimonials[currentTestimonial].avatar}
                </div>
                <div className="text-left">
                  <h4 className="text-burlap-800 font-bold text-base sm:text-lg font-display">{testimonials[currentTestimonial].name}</h4>
                  <p className="text-primary-600 font-medium text-sm sm:text-base">{testimonials[currentTestimonial].role}</p>
                  <p className="text-burlap-500 text-xs sm:text-sm">{testimonials[currentTestimonial].company}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex justify-center items-center space-x-6 mt-6 sm:mt-8">
            <button
              onClick={prevTestimonial}
              className="w-10 h-10 sm:w-12 sm:h-12 bg-white/60 backdrop-blur-sm rounded-full flex items-center justify-center text-burlap-700 hover:bg-white hover:text-primary-600 transition-all duration-300 border-2 border-cream-200 hover:border-primary-300 shadow-lg"
            >
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            {/* Dots Indicator */}
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                    index === currentTestimonial 
                      ? 'bg-primary-500 scale-125' 
                      : 'bg-burlap-300 hover:bg-primary-300'
                  }`}
                />
              ))}
            </div>
            
            <button
              onClick={nextTestimonial}
              className="w-10 h-10 sm:w-12 sm:h-12 bg-white/60 backdrop-blur-sm rounded-full flex items-center justify-center text-burlap-700 hover:bg-white hover:text-primary-600 transition-all duration-300 border-2 border-cream-200 hover:border-primary-300 shadow-lg"
            >
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
